// The following should NOT be used
// use the variables with that starts with lowecase.
var DateFormat = 'MM/DD/YYYY';
var TimeFormat = 'hh:mm:ss A';
var TimeFormatRead = 'LT';
var DateTimeFormat = DateFormat + ' ' + TimeFormatRead;
var DateTimeFormatDb = 'YYYY-MM-DD HH:mm:ss';
var DateFormatDb = 'YYYY-MM-DD';
var DateTimeFormatForEdit = DateFormat + ' ' + TimeFormat;

var dateFormat = 'MM/DD/YYYY';
var timeFormat = 'hh:mm:ss A';
var timeFormatRead = 'LT';
var dateTimeFormat = dateFormat + ' ' + timeFormatRead;
var dateTimeFormatDb = 'YYYY-MM-DD HH:mm:ss';
var dateFormatDb = 'YYYY-MM-DD';
var dateTimeFormatForEdit = dateFormat + ' ' + timeFormat;
var monthFormat = 'MM/YYYY';

// GLOBAL CONSTANTS
// -----------------------------------
(function (window, document, $, undefined) {
    window.APP_COLORS = {
        'primary': '#5d9cec',
        'success': '#27c24c',
        'info': '#23b7e5',
        'warning': '#ff902b',
        'danger': '#f05050',
        'inverse': '#131e26',
        'green': '#37bc9b',
        'pink': '#f532e5',
        'purple': '#7266ba',
        'dark': '#3a3f51',
        'yellow': '#fad732',
        'gray-darker': '#232735',
        'gray-dark': '#3a3f51',
        'gray': '#dde6e9',
        'gray-light': '#e4eaec',
        'gray-lighter': '#edf1f2'
    };

    window.APP_MEDIAQUERY = {
        'desktopLG': 1200,
        'desktop': 992,
        'tablet': 768,
        'mobile': 480
    };
})(window, document, window.jQuery);

